// Every way to log food, in one place. Owned by a lib rather than a component
// because the Today grid is now the only surface that renders them — there is
// no chooser sheet any more.
import { Camera, PencilLine, ScanBarcode, Zap, CopyPlus, Mic, Bookmark, type LucideIcon } from "lucide-react";

export type LogMethod = "barcode" | "photo" | "describe" | "voice" | "saved" | "quick" | "copy_yesterday";

/** Order is fixed and never personalised — a control that moves is one you have
 *  to re-find every time (UI plan §1: consistent before novel). Most-used
 *  first, so the top row carries the daily methods. */
export const LOG_OPTIONS: {
  method: LogMethod;
  icon: LucideIcon;
  tint: string;
  /** Short label for the grid — four columns leave ~85px, and German runs long
   *  (UI plan §11), so these are deliberately not the prose labels. */
  short: string;
}[] = [
  { method: "photo",          icon: Camera,     tint: "#a3e635", short: "log.short.photo" },
  { method: "barcode",        icon: ScanBarcode, tint: "#06b6d4", short: "log.short.scan" },
  { method: "describe",       icon: PencilLine, tint: "#8b5cf6", short: "log.short.text" },
  { method: "voice",          icon: Mic,        tint: "#ef4444", short: "log.short.voice" },
  { method: "saved",          icon: Bookmark,   tint: "#10b981", short: "log.short.saved" },
  { method: "quick",          icon: Zap,        tint: "#f59e0b", short: "log.short.quick" },
  { method: "copy_yesterday", icon: CopyPlus,   tint: "#64748b", short: "log.short.copy" },
];

/** The Premium logging methods, by owner decision (2026-08-07): photo and
 *  voice. Barcode scanning is FREE to use — the gate moved to the nutrition
 *  DETAIL values (macros/micros), which show as Pro-locked in every logging
 *  flow (see ProLock.tsx). Text, saved meals, quick add and copy stay free.
 *  A 7-day trial counts as premium, so trial users see no locks anywhere. */
export const PREMIUM_METHODS: LogMethod[] = ["photo", "voice"];

export function premiumOnly(m: LogMethod): boolean {
  return PREMIUM_METHODS.includes(m);
}
